var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C1D84E9E-FC4E-4077-BDF2-303D166C61D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footers-#1",
    transform: "translate(-1263.000000, -511.000000)",
    fill: "#D8BE8D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copyright",
    transform: "translate(0.000000, 485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-links",
    transform: "translate(1130.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram-icon",
    transform: "translate(133.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,0 L3.75,0 C1.6875,0 0,1.6875 0,3.75 L0,11.25 C0,13.3125 1.6875,15 3.75,15 L11.25,15 C13.3125,15 15,13.3125 15,11.25 L15,3.75 C15,1.6875 13.3125,0 11.25,0 Z M14,11.075 C14,12.68375 12.68375,14 11.075,14 L3.925,14 C2.31625,14 1,12.68375 1,11.075 L1,3.925 C1,2.31625 2.31625,1 3.925,1 L11.075,1 C12.68375,1 14,2.31625 14,3.925 L14,11.075 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3.5 C5.3,3.5 3.5,5.3 3.5,7.5 C3.5,9.7 5.3,11.5 7.5,11.5 C9.7,11.5 11.5,9.7 11.5,7.5 C11.5,5.3 9.7,3.5 7.5,3.5 Z M7.5,10.5 C5.85,10.5 4.5,9.15 4.5,7.5 C4.5,5.85 5.85,4.5 7.5,4.5 C9.15,4.5 10.5,5.85 10.5,7.5 C10.5,9.15 9.15,10.5 7.5,10.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C11.4428571,3 11,3.44285714 11,4 C11,4.55714286 11.4428571,5 12,5 C12.5571429,5 13,4.55714286 13,4 C13,3.44285714 12.5571429,3 12,3 Z M12,4.5 C11.7166667,4.5 11.5,4.28333333 11.5,4 C11.5,3.71666667 11.7166667,3.5 12,3.5 C12.2833333,3.5 12.5,3.71666667 12.5,4 C12.5,4.28333333 12.2833333,4.5 12,4.5 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.45f27e44f2e9231342a7fd7fe7d7a32e.svg";
export { ForwardRef as ReactComponent };